import { render, staticRenderFns } from "./suola-orders.vue?vue&type=template&id=54299820&scoped=true&"
import script from "./suola-orders.vue?vue&type=script&lang=js&"
export * from "./suola-orders.vue?vue&type=script&lang=js&"
import style0 from "./suola-orders.vue?vue&type=style&index=0&id=54299820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54299820",
  null
  
)

export default component.exports